import React, { useEffect, useState } from "react";
import { Row, Col, Form, Select } from "antd";

const { Option } = Select;

const BranchLocationSelector = ({
    loginPlaceId,
    districtData,
    districtName,
    divisionalId,
    onChange // 👈 callback to parent
}) => {

    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedDivisional, setSelectedDivisional] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);

    const [availableDivisionals, setAvailableDivisionals] = useState([]);
    const [availableBranches, setAvailableBranches] = useState([]);

    /* -----------------------------
       AUTO SET DISTRICT (login=4)
    ------------------------------*/
    useEffect(() => {
        if (loginPlaceId === "4" && districtName) {
            const district = districtData.find(
                d => d.districtName === districtName
            );
            if (district) {
                setSelectedDistrict(district.districtId);
            }
        }
    }, [loginPlaceId, districtName, districtData]);

    /* -----------------------------
       DISTRICT → DIVISIONAL
    ------------------------------*/
    // useEffect(() => {
    //     if (!selectedDistrict) {
    //         setAvailableDivisionals([]);
    //         setAvailableBranches([]);
    //         setSelectedDivisional(null);
    //         setSelectedBranch(null);
    //         return;
    //     }

    //     const district = districtData.find(
    //         d => d.districtId === selectedDistrict
    //     );

    //     setAvailableDivisionals(district?.divisionalAreaDtoList || []);

    //     if (loginPlaceId === "2" && divisionalId) {
    //         setSelectedDivisional([divisionalId]);
    //     }
    //     console.log("selected Divisional set to:", divisionalId);

    // }, [selectedDistrict, districtData, loginPlaceId, divisionalId]);

    useEffect(() => {
        let filteredDivisionalAreas = [];

        if (loginPlaceId === "2" && divisionalId) {
            filteredDivisionalAreas = districtData
                .flatMap(d => d.divisionalAreaDtoList || [])
                .filter(div => div.divAId === divisionalId);

            setAvailableDivisionals(filteredDivisionalAreas);
        } else {
            filteredDivisionalAreas = districtData
                .filter(d => selectedDistrict === d.districtId)
                .flatMap(d => d.divisionalAreaDtoList || []);

            setAvailableDivisionals(prev =>
                prev.filter(did =>
                    filteredDivisionalAreas.some(d => d.divAId === did)
                )
            );
        }

        setAvailableDivisionals(filteredDivisionalAreas);
    }, [setSelectedDivisional, districtData, loginPlaceId, setAvailableDivisionals, divisionalId, selectedDistrict]);

    /* -----------------------------
       DIVISIONAL → BRANCH
    ------------------------------*/
    useEffect(() => {
        if (!selectedDivisional) {
            setAvailableBranches([]);
            setSelectedBranch(null);
            return;
        }

        const divisional = availableDivisionals.find(
            d => d.divAId === selectedDivisional
        );

        setAvailableBranches(divisional?.branchDtoList || []);
    }, [selectedDivisional, availableDivisionals]);

    /* -----------------------------
       SEND DATA TO PARENT
    ------------------------------*/
    useEffect(() => {
        if (!onChange) return;

        const selectedBranchObj = availableBranches.find(
            b => b.id === selectedBranch
        );

        onChange({
            districtId: selectedDistrict,
            divisionalId: selectedDivisional,
            branchId: selectedBranch,
            branchName: selectedBranchObj?.branchName || null
        });

    }, [selectedDistrict, selectedDivisional, selectedBranch, availableBranches, onChange]);

    return (
        <Row gutter={[16, 16]}>

            {/* District */}
            {(loginPlaceId === "3" || loginPlaceId === "4") && (
                <Col span={24}>
                    <Form.Item label="District">
                        <Select
                            placeholder="Select District"
                            value={selectedDistrict}
                            onChange={setSelectedDistrict}
                        >
                            {districtData
                                .filter(d =>
                                    loginPlaceId === "4"
                                        ? d.districtName === districtName
                                        : true
                                )
                                .map(d => (
                                    <Option key={d.districtId} value={d.districtId}>
                                        🏙️ {d.districtName}
                                    </Option>
                                ))}
                        </Select>
                    </Form.Item>
                </Col>
            )}

            {/* Divisional */}
            {(loginPlaceId === "3" || loginPlaceId === "4" || loginPlaceId === "2") && (
                <Col span={24}>
                    <Form.Item label="Divisional Area">
                        <Select
                            placeholder="Select Divisional"
                            value={selectedDivisional}
                            onChange={setSelectedDivisional}
                        // disabled={!availableDivisionals.length}
                        >
                            {availableDivisionals.map(d => (
                                <Option key={d.divAId} value={d.divAId}>
                                    🏘️ {d.divAIdName}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            )}

            {(loginPlaceId === "3" || loginPlaceId === "4" || loginPlaceId === "2") && (
                <Col span={24}>
                    <Form.Item label="Branch">
                        <Select
                            placeholder="Select Branch"
                            value={selectedBranch}
                            onChange={setSelectedBranch}
                            disabled={!availableBranches.length}
                        >
                            {availableBranches.map(b => (
                                <Option key={b.id} value={b.id}>
                                    🏢 {b.branchName}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            )}

        </Row>
    );
};

export default BranchLocationSelector;
